/**
 * Hook de autenticação - wrapper para o auth store
 * Fornece uma interface simplificada para componentes que precisam de user e logout
 */
import { useAuthStore } from '../stores/auth.store';

export function useAuth() {
  const user = useAuthStore((state) => state.user);
  const logout = useAuthStore((state) => state.logout);
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated);
  const isLoading = useAuthStore((state) => state.isLoading);
  const error = useAuthStore((state) => state.error);
  const isSuperAdmin = useAuthStore((state) => state.isSuperAdmin);
  const isTenantAdmin = useAuthStore((state) => state.isTenantAdmin);
  const isCorrentista = useAuthStore((state) => state.isCorrentista);
  const hasCategory = useAuthStore((state) => state.hasCategory);
  const getDefaultRoute = useAuthStore((state) => state.getDefaultRoute);
  const getProfileRoute = useAuthStore((state) => state.getProfileRoute);

  return {
    user,
    logout,
    isAuthenticated,
    isLoading,
    error,
    isSuperAdmin,
    isTenantAdmin,
    isCorrentista,
    hasCategory,
    getDefaultRoute,
    getProfileRoute,
  };
}

export default useAuth;
